requestAnimationFrame(() => {
  themeBase.onDOMContentLoadedTrigger(() => {
    if (customElements.get('bottom-navigation')) return;

    class BottomNavigation extends HTMLElement {
      constructor() {
        super();

        this.visibleClass = 'bottom-navigation--visible';
        this.controlAttribute = 'data-scroll-controlled';

        this.onScrollHandler = this.onScroll.bind(this);
        this.onResizeHandler = this.onResize.bind(this);
      }

      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.dataset.scrollControlled = 'true';

        this.updateHeaderReference();
        this.toggleVisibility();
        this.updateCSSVariable();

        window.addEventListener('throttle30fpsScroll', this.onScrollHandler, {
          passive: true
        });
        window.addEventListener('throttle30fpsResize', this.onResizeHandler);
      }

      disconnectedCallback() {
        window.removeEventListener('throttle30fpsScroll', this.onScrollHandler);
        window.removeEventListener('throttle30fpsResize', this.onResizeHandler);

        if (this.headerObserver) {
          this.headerObserver.disconnect();
          this.headerObserver = null;
        }

        this.initialized = false;
        this.removeAttribute(this.controlAttribute);
        this.classList.remove(this.visibleClass);
      }

      updateHeaderReference() {
        const header = document.querySelector('.header');

        if (header !== this.header) {
          if (this.headerObserver) {
            this.headerObserver.disconnect();
          }

          this.header = header;

          if (this.header && 'ResizeObserver' in window) {
            this.headerObserver = new ResizeObserver(() => {
              this.updateHeaderHeight();
              this.toggleVisibility();
            });

            this.headerObserver.observe(this.header);
          } else {
            this.headerObserver = null;
          }
        }

        this.updateHeaderHeight();
      }

      updateCSSVariable() {
        document.documentElement.style.setProperty('--bottom-navigation-height', `${themeBounds.get(this).height.toFixed(1) / 10}rem`);
      }

      updateHeaderHeight() {
        this.headerHeight = this.header ? this.header.offsetHeight : 0;
      }

      onResize() {
        this.updateHeaderReference();
        this.toggleVisibility();
        this.updateCSSVariable();
      }

      onScroll() {
        this.toggleVisibility();
      }

      toggleVisibility() {
        const shouldShow = window.pageYOffset > this.headerHeight;
        this.classList.toggle(this.visibleClass, shouldShow);
      }
    }

    customElements.define('bottom-navigation', BottomNavigation);
  });
});